import { StatusDotPill } from '@/shared';
import { formatChileanDate } from '@/lib';
import { STATUS_PILL } from './intakeStatus';

const fmtDate = (iso) => formatChileanDate(iso) || '—';

// Clicks that land on a control inside the card keep their own meaning.
const INNER_CONTROL = 'button, a, input, select, textarea, label';

// One WhatsApp intake in the queue. The summary (date, status, sender and
// preview) is the button that opens the detail; Aceptar, Rechazar and Kapso
// stay outside it. `selected` marks the row the ?id= points at, and
// `scrollRef` is the callback ref that scrolls it into view.
export default function WhatsAppIntakeCard({
  row,
  selected = false,
  scrollRef,
  controls,
  onOpen,
  busy = false,
  preflightOpen = false,
  accepting = false,
  onAccept,
  onReject,
}) {
  const st = STATUS_PILL[row.status] ?? STATUS_PILL.pending;
  const canDecide = row.status === 'pending';
  const actionsDisabled = preflightOpen || busy;
  // A mouse click anywhere on the card also opens it. Keyboard users reach the
  // same action through the summary button, so the article needs no role.
  const onCardClick = (e) => {
    if (e.target instanceof Element && e.target.closest(INNER_CONTROL)) return;
    onOpen?.(row);
  };
  return (
    <article
      ref={selected ? scrollRef : undefined}
      className={`plp-card pli-card${selected ? ' is-selected' : ''}`}
      onClick={onCardClick}
    >
      <button
        type="button"
        className="pli-card__open"
        aria-current={selected ? 'true' : undefined}
        aria-controls={controls}
        data-intake-open={row.id}
        onClick={() => onOpen?.(row)}
      >
        <span className="plp-card__lead">
          <span className="plp-date">{fmtDate(row.updatedAt)}</span>
          <StatusDotPill status={st.tone} label={st.label} />
        </span>
        <span className="plp-card__fields">
          <span className="plp-cf">
            <span className="plp-cf__l">Remitente</span>
            <span className="plp-cf__v">{row.sender || '—'}</span>
          </span>
          <span className="plp-cf">
            <span className="plp-cf__l">Preview</span>
            <span className="plp-cf__v">{row.preview || '—'}</span>
          </span>
        </span>
      </button>
      <div className="pli-card__actions">
        {canDecide && (
          <div className="plp-actions">
            <button
              type="button"
              className="plp-rowbtn"
              disabled={actionsDisabled}
              onClick={() => onAccept(row)}
            >
              {busy && accepting ? '…' : 'Aceptar'}
            </button>
            <button
              type="button"
              className="plp-rowbtn plp-rowbtn--ghost"
              disabled={actionsDisabled}
              onClick={() => onReject(row)}
            >
              Rechazar
            </button>
          </div>
        )}
        <a
          className="pli-kapso"
          href={row.kapsoInboxUrl}
          target="_blank"
          rel="noreferrer"
        >
          Abrir en Kapso
        </a>
      </div>
    </article>
  );
}
